import { Box, ListItem } from '@chakra-ui/react';
import { ListView } from 'components/molecules/ListView';
import { FC } from 'react';
import { useListStore } from '../../hooks';
import { TaskListHeader } from './TaskListHeader';
import { TaskListItem } from './TaskListItem';

type UseListStoreReturnType = ReturnType<typeof useListStore>;

type Props = {
  listItems: UseListStoreReturnType['releaseTasks'];
  handleEditOpenModal: UseListStoreReturnType['onOpenModal'];
};

export const TaskListView: FC<Props> = ({ listItems, handleEditOpenModal }) => (
  <>
    <Box m="20px 0 0 0">
      <TaskListHeader />
    </Box>
    <ListView>
      {listItems.map((item) => (
        <ListItem key={item.taskId} listStyleType="none">
          <TaskListItem
            item={item}
            handleClickRow={() => handleEditOpenModal(item)}
          />
        </ListItem>
      ))}
    </ListView>
  </>
);
